module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu",
    staticStyle: {
      "background": "url(static/images/backgroundcs.png) no-repeat bottom",
      "background-color": "#A7D7F5",
      "background-size": "100%",
      "height": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "muenBoxs"
  }, [_c('div', {
    staticClass: "parents"
  }, [(_vm.allMenu.repairApplicationManagement) ? _c('div', {
    staticClass: "gridCell",
    on: {
      "click": function($event) {
        return _vm.openPage('/RepairApply', '')
      }
    }
  }, [_c('div', {
    staticClass: "btimg d_icon_10",
    staticStyle: {
      "background": "url(static/images/jt.png) 0% 73% no-repeat",
      "background-size": "333.33%",
      "background-color": "#3C8DFF"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("校园网络故障报修")])]) : _vm._e(), _vm._v(" "), (_vm.allMenu.maintenanceManagement) ? _c('div', {
    staticClass: "gridCell",
    on: {
      "click": function($event) {
        return _vm.openPage('/RepairManger', '')
      }
    }
  }, [_c('div', {
    staticClass: "btimg d_icon_10",
    staticStyle: {
      "background": "url(static/images/jt.png) 0% 73% no-repeat",
      "background-size": "333.33%",
      "background-color": "#3C8DFF"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("维修管理")])]) : _vm._e(), _vm._v(" "), (_vm.allMenu.integrationPackageReview) ? _c('div', {
    staticClass: "gridCell",
    on: {
      "click": function($event) {
        return _vm.openPage('/FusePackageProblem', '')
      }
    }
  }, [_c('div', {
    staticClass: "btimg d_icon_10",
    staticStyle: {
      "background": "url(static/images/jt.png) 0% 73% no-repeat",
      "background-size": "333.33%",
      "background-color": "#3C8DFF"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("融合套餐审核")])]) : _vm._e(), _vm._v(" "), (_vm.allMenu.delayedMaintenanceAudit) ? _c('div', {
    staticClass: "gridCell",
    on: {
      "click": function($event) {
        return _vm.openPage('/DelayedMaintenanceAudit', '')
      }
    }
  }, [_c('div', {
    staticClass: "btimg d_icon_10",
    staticStyle: {
      "background": "url(static/images/jt.png) 0% 73% no-repeat",
      "background-size": "333.33%",
      "background-color": "#3C8DFF"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("延迟维修审核")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gridCell",
    on: {
      "click": function($event) {
        return _vm.loginOut()
      }
    }
  }, [_c('div', {
    staticClass: "btimg d_icon_10",
    staticStyle: {
      "background": "url(static/images/jt.png) 0% 73% no-repeat",
      "background-size": "333.33%",
      "background-color": "#3C8DFF"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("退出登录")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topLogo"
  }, [_c('img', {
    staticClass: "leftLogo",
    attrs: {
      "src": "static/images/logoblack.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "rightLogo",
    attrs: {
      "src": "static/images/wsbsdt.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a18a6f5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/indexMenuRepairApply.vue
// module id = 847
// module chunks = 1